import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../../styles/theme";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import * as React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PaymentIcon from "@mui/icons-material/Payment";
import TollIcon from "@mui/icons-material/Toll";
import TransformIcon from "@mui/icons-material/Transform";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import AnimationIcon from "@mui/icons-material/Animation";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import SecurityUpdateIcon from "@mui/icons-material/SecurityUpdate";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import SecurityIcon from "@mui/icons-material/Security";
import axios from "axios";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AppsIcon from "@mui/icons-material/Apps";
import SummarizeIcon from "@mui/icons-material/Summarize";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import EngineeringIcon from "@mui/icons-material/Engineering";
import Switch from "@mui/material/Switch";
import packageJson from "../../../../package.json";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('images-1.png')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('6742-no-configuration-setting.png')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};
const Sidebar = () => {
  const staff_type = localStorage.getItem("staff_type");
  const mobile_number_login = localStorage.getItem("mobile_number_login");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [isToggled, setIsToggled] = useState(0);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/getConfigMode`, {
        withCredentials: true,
      })
      .then((response) => {
        setIsToggled(response.data.data.maintenance_mode);
      });
  }, []);
  const handleClick = () => {
    setOpen(!open);
  };
  const [open1, setOpen1] = React.useState(false);
  const handleClick1 = () => {
    setOpen1(!open1);
  };
  const [open2, setOpen2] = React.useState(false);
  const handleClick2 = () => {
    setOpen2(!open2);
  };
  const [open3, setOpen3] = React.useState(false);
  const handleClick3 = () => {
    setOpen3(!open3);
  };
  const [open7, setOpen7] = React.useState(false);
  const handleClick7 = () => {
    setOpen7(!open7);
  };
  const [open8, setOpen8] = React.useState(false);
  const handleClick8 = () => {
    setOpen8(!open8);
  };
  const [open9, setOpen9] = React.useState(false);
  const handleClick9 = () => {
    setOpen9(!open9);
  };
  const [open10, setOpen10] = React.useState(false);
  const handleClick10 = () => {
    setOpen10(!open10);
  };
  const [open12, setOpen12] = React.useState(false);
  const handleClick12 = () => {
    setOpen12(!open12);
  };
  const [open11, setOpen11] = React.useState(false);
  const handleClick11 = () => {
    setOpen11(!open11);
  };
  const [open14, setOpen14] = React.useState(false);
  const handleClick14 = () => {
    setOpen14(!open14);
  };

  const [open5, setOpen5] = React.useState(false);
  const handleClick5 = () => {
    setOpen5(!open5);
  };

  const [open4, setOpen4] = React.useState(false);
  const [Firstname, setFirstname] = React.useState([]);
  const [stafftype, setstafftype] = React.useState([]);
  const [services, setservices] = React.useState([]);
  const [TransferUnit, setTransferUnit] = React.useState([]);
  const [billmobile, setBillMobile] = React.useState([]);
  const [order, setOrder] = React.useState([]);
  const [transaction, setTransaction] = React.useState([]);
  const [img, setImg] = useState([]);
  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleClick4 = () => {
    setOpen4(!open4);
  };

  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/getSignupRequest`, {
        withCredentials: true,
      })
      .then((res) => {
        setFirstname(res.data.data.first_name + " " + res.data.data.last_name);
        setstafftype(res.data.data.staff_type);
        setImg(res.data.data.images.personal_photo);
      })
      .catch((err) => {});
  },[]);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/getActiveService`, {
        withCredentials: true,
      })
      .then((res) => {
        setservices(res.data.data);
      })
      .catch((err) => {});
  }, [staff_type]);
  const locale = localStorage.getItem("is loggedIn");
  const handleToggle = (event) => {
    const newToggleState = event.target.checked ? 1 : 0;
    setIsToggled(newToggleState);
    if (newToggleState == 0) {
      // API to set the new toggle state
      axios
        .post(
          `${BaseUrl}/api/makeAppNotMaintenanceMode`,
          {
            maintenance_mode: newToggleState,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {})
        .catch((error) => {});
    } else if (newToggleState == 1) {
      // API to set the new toggle state
      axios
        .post(
          `${BaseUrl}/api/makeAppInMaintenanceMode`,
          {
            maintenance_mode: newToggleState,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {})
        .catch((error) => {});
    }
  };
  if (locale === "true") {
    return (
      <Box
        className="custom_sidebar"
        sx={{
          "& .pro-sidebar-inner": {},
          "& .pro-icon-wrapper": {
            backgroundColor: "transparent !important",
          },
          "& .pro-inner-item": {
            padding: "0px !important",
            color: `#297FB8 !important`,
          },
          "& .pro-inner-item button": {
            color: `#297FB8 !important`,
          },
          "& .pro-item-content > p": {
            fontSize: "16px !important",
            fontWeight: "600",
          },
          "& .pro-inner-item:hover": {
            color: "#297FB8 !important",
          },
          "& .pro-menu-item.active": {
            color: "#297FB8 !important",
          },
        }}
      >
        <ProSidebar collapsed={isCollapsed}>
          <Menu iconShape="square">
            <MenuItem
              onClick={() => setIsCollapsed(!isCollapsed)}
              icon={isCollapsed ? <MenuOutlinedIcon /> : <MenuOutlinedIcon />}
              style={{
                margin: "10px 0 20px 0",
                color: colors.grey[100],
              }}
            >
              {!isCollapsed && (
                <Box mb="25px">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <img
                      alt="profile-user"
                      width="100px"
                      height="100px"
                      src={img}
                      style={{ cursor: "pointer", borderRadius: "50%" }}
                    />
                  </Box>
                  <Box textAlign="center">
                    <Typography
                      variant="h2"
                      color={colors.primary[600]}
                      fontWeight="bold"
                      sx={{ m: "10px 0 0 0" }}
                      className="title-client"
                    >
                      {Firstname}
                    </Typography>
                    <Typography variant="h5" color={colors.redAccent[500]}>
                      {stafftype}
                    </Typography>
                  </Box>
                </Box>
              )}
            </MenuItem>
            <List
              sx={{ width: "100%", maxWidth: 360, bgcolor: "#FFF" }}
              component="nav"
            >
              {staff_type !== "Admin" ? (
                <ListItemButton
                  component={Link}
                  to="/dashboard"
                  className="btn-sidebare"
                >
                  <ListItemIcon>
                    <AppsIcon />
                  </ListItemIcon>
                  <ListItemText
                    className="title-sidebar"
                    primary="لوحة التحكم"
                  />
                </ListItemButton>
              ) : (
                <ListItemButton
                  component={Link}
                  to="/dashboard"
                  className="btn-sidebare"
                >
                  <ListItemIcon>
                    <AppsIcon />
                  </ListItemIcon>
                  <ListItemText
                    className="title-sidebar"
                    primary="لوحة التحكم"
                  />
                </ListItemButton>
              )}
              {staff_type !== "Admin" ? (
                <></>
              ) : (
                <>
                  <ListItemButton
                    className="btn-sidebare"
                    onClick={handleClick}
                  >
                    <ListItemIcon>
                      <PeopleAltIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="إدارة المستخدمين"
                    />
                    {open ? (
                      <ExpandLess className="openChanel" />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>
                  <Collapse
                    in={open}
                    timeout="auto"
                    unmountOnExit
                    className="collapse-sidebar"
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/staff"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="استعراض المستخدمين"
                        />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/create-staff"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="إنشاء مستخدم جديد"
                        />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/staffReqest"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="طلبات الانضمام"
                        />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/staffDeleted"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="الحسابات المحذوفة"
                        />
                      </ListItemButton>
                    </List>
                  </Collapse>
                  {staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
                    <ListItemButton
                      className="btn-sidebare"
                      onClick={handleClick7}
                    >
                      <ListItemIcon>
                        <AnimationIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="نقاط البيع"
                      />
                      {open3 ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                  ) : (
                    <></>
                  )}

                  <Collapse
                    in={open7}
                    timeout="auto"
                    className="collapse-sidebar"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="providers"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="نقاط بيع Syriatel"
                        />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="providers-mtn"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary=" نقاط بيع MTN "
                        />
                      </ListItemButton>
                    </List>
                  </Collapse>
                  {staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
                    <ListItemButton
                      component={Link}
                      to="/Banks"
                      className="btn-sidebare"
                    >
                      <ListItemIcon>
                        <AccountBalanceIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="البنوك"
                      />
                    </ListItemButton>
                  ) : (
                    <></>
                  )}

                  {staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
                    <ListItemButton
                      component={Link}
                      to="/payment-method"
                      className="btn-sidebare"
                    >
                      <ListItemIcon>
                        <PaymentIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="طرق الدفع"
                      />
                    </ListItemButton>
                  ) : (
                    <></>
                  )}
                  <ListItemButton
                    component={Link}
                    to="/Citeis"
                    className="btn-sidebare"
                  >
                    <ListItemIcon>
                      <AppsIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="المحافظات والمناطق"
                    />
                  </ListItemButton>
                  {staff_type !== "Admin" ? (
                      <>
                        <ListItemButton
                          className="btn-sidebare"
                          onClick={handleClick10}
                        >
                          <ListItemIcon>
                            <AnimationIcon />
                          </ListItemIcon>
                          <ListItemText
                            className="title-sidebar"
                            primary="دفع الكتروني"
                          />
                          {open10 ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse
                          in={open10}
                          timeout="auto"
                          className="collapse-sidebar"
                          unmountOnExit
                        >
                          <List component="div" disablePadding>
                            <ListItemButton
                              component={Link}
                              to="e-payment"
                              sx={{ pl: 4 }}
                            >
                              <ListItemText
                                className="title-sidebar"
                                primary="تحويلات الدفع الكتروني"
                              />
                            </ListItemButton>
                            <ListItemButton
                              component={Link}
                              to="create-epayment"
                              sx={{ pl: 4 }}
                            >
                              <ListItemText
                                className="title-sidebar"
                                primary="إضافة دفع الكتروني"
                              />
                            </ListItemButton>
                            <ListItemButton
                              component={Link}
                              to="config-epayment"
                              sx={{ pl: 4 }}
                            >
                              <ListItemText
                                className="title-sidebar"
                                primary="إعدادات الدفع الالكتروني"
                              />
                            </ListItemButton>
                          </List>
                        </Collapse>
                      </>
                    ) :
                      staff_type === "Admin" ? (
                      <>
                        <ListItemButton
                          className="btn-sidebare"
                          onClick={handleClick10}
                        >
                          <ListItemIcon>
                            <AnimationIcon />
                          </ListItemIcon>
                          <ListItemText
                            className="title-sidebar"
                            primary="دفع الكتروني"
                          />
                          {open10 ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse
                          in={open10}
                          timeout="auto"
                          className="collapse-sidebar"
                          unmountOnExit
                        >
                          <List component="div" disablePadding>
                            <ListItemButton
                              component={Link}
                              to="e-payment"
                              sx={{ pl: 4 }}
                            >
                              <ListItemText
                                className="title-sidebar"
                                primary="تحويلات الدفع الكتروني"
                              />
                            </ListItemButton>
                            <ListItemButton
                              component={Link}
                              to="create-epayment"
                              sx={{ pl: 4 }}
                            >
                              <ListItemText
                                className="title-sidebar"
                                primary="إضافة دفع الكتروني"
                              />
                            </ListItemButton>
                            <ListItemButton
                              component={Link}
                              to="config-epayment"
                              sx={{ pl: 4 }}
                            >
                              <ListItemText
                                className="title-sidebar"
                                primary="إعدادات الدفع الالكتروني"
                              />
                            </ListItemButton>
                          </List>
                        </Collapse>
                      </>
                    ) : (
                      <></>
                    
                  )}
                  {staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
                    <ListItemButton
                      component={Link}
                      to="/services"
                      className="btn-sidebare"
                    >
                      <ListItemIcon>
                        <PaymentIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="الخدمات"
                      />
                    </ListItemButton>
                  ) : (
                    <></>
                  )}

                  {staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
                    <>
                      <ListItemButton
                        className="btn-sidebare"
                        onClick={handleClick1}
                      >
                        <ListItemIcon>
                          <TollIcon />
                        </ListItemIcon>
                        <ListItemText
                          className="title-sidebar"
                          primary="إدارة الرصيد"
                        />
                        {open1 ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse
                        in={open1}
                        timeout="auto"
                        className="collapse-sidebar"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          <ListItemButton
                            component={Link}
                            to="getfund"
                            sx={{ pl: 4 }}
                          >
                            <ListItemText
                              className="title-sidebar"
                              primary="استعراض الأرصدة"
                            />
                          </ListItemButton>
                        </List>
                      </Collapse>
                    </>
                  ) : (
                    <></>
                  )}

                  {staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
                    <>
                      <ListItemButton
                        className="btn-sidebare"
                        onClick={handleClick11}
                      >
                        <ListItemIcon>
                          <TollIcon />
                        </ListItemIcon>
                        <ListItemText
                          className="title-sidebar"
                          primary="أرصدة شركات الاتصالات"
                        />
                        {open11 ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse
                        in={open11}
                        timeout="auto"
                        className="collapse-sidebar"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>
                          <ListItemButton
                            component={Link}
                            to="company-balance"
                            sx={{ pl: 4 }}
                          >
                            <ListItemText
                              className="title-sidebar"
                              primary="الأرصدة"
                            />
                          </ListItemButton>
                          <ListItemButton
                            component={Link}
                            to="shipping-operations"
                            sx={{ pl: 4 }}
                          >
                            <ListItemText
                              className="title-sidebar"
                              primary="سجل عمليات الشحن"
                            />
                          </ListItemButton>
                        </List>
                      </Collapse>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}

            
                  <ListItemButton
                    component={Link}
                    to="/transfar-fund-cache"
                    className="btn-sidebare"
                  >
                    <ListItemIcon>
                      <AdUnitsIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="تحويل رصيد ليرتنا كاش"
                    />
                  </ListItemButton>
           
              {staff_type !== "Admin" ? (
                <ListItemButton
                  component={Link}
                  to="/order-fund-cache"
                  className="btn-sidebare"
                >
                  <ListItemIcon>
                    <TransformIcon />
                  </ListItemIcon>
                  <ListItemText
                    className="title-sidebar"
                    primary="طلب  رصيد ليرتنا كاش"
                  />
                </ListItemButton>
              ) : (
                <></>
              )}
            
                  <ListItemButton
                    component={Link}
                    to="/convert-unite"
                    className="btn-sidebare"
                  >
                    <ListItemIcon>
                      <PhoneIphoneIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="تحويل وحدات"
                    />
                  </ListItemButton>
             

            
                  <ListItemButton
                    component={Link}
                    to="/pay-bill"
                    className="btn-sidebare"
                  >
                    <ListItemIcon>
                      <TransformIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="دفع فاتورة Syriarel / MTN"
                    />
                  </ListItemButton>
          

     
                  <ListItemButton
                    component={Link}
                    to="/balance-transfer-cache-mobile"
                    className="btn-sidebare"
                  >
                    <ListItemIcon>
                      <SecurityUpdateIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="تحويل رصيد كاش موبايل"
                    />
                  </ListItemButton>
            

              {staff_type !== "Admin" ? (
                  <>
                    <ListItemButton
                      className="btn-sidebare"
                      onClick={handleClick9}
                    >
                      <ListItemIcon>
                        <AssignmentReturnIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary=" الطلبات"
                      />
                      {open9 ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse
                      in={open9}
                      timeout="auto"
                      className="collapse-sidebar"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          component={Link}
                          to="/order-from"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="استعراض الطلبات الصادرة"
                          />
                        </ListItemButton>

                        <ListItemButton
                          component={Link}
                          to="/order-to"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="استعراض الطلبات الواردة"
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </>
                ) :  staff_type === "Admin" ? (
                  <>
                    <ListItemButton
                      className="btn-sidebare"
                      onClick={handleClick5}
                    >
                      <ListItemIcon>
                        <AssignmentReturnIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary=" الطلبات"
                      />
                      {open5 ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse
                      in={open5}
                      timeout="auto"
                      className="collapse-sidebar"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          component={Link}
                          to="/orderpaid"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="استعراض الطلبات  مدفوعة"
                          />
                        </ListItemButton>

                        <ListItemButton
                          component={Link}
                          to="/orderunpaid"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="استعراض الطلبات الغير مدفوعة"
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </>
                ) : (
                  <></>
                
              )}

              {staff_type !== "Admin" ? (
                  <>
                    <ListItemButton
                      className="btn-sidebare"
                      onClick={handleClick8}
                    >
                      <ListItemIcon>
                        <SyncAltIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="التحويلات"
                      />
                      {open8 ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse
                      in={open8}
                      timeout="auto"
                      className="collapse-sidebar"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          component={Link}
                          to="/transcation-from"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="استعراض التحويلات  الصادرة"
                          />
                        </ListItemButton>

                        <ListItemButton
                          component={Link}
                          to="/transcation-to"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="استعراض التحويلات الواردة"
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </>
                ) : 
                  staff_type === "Admin" ? (
                  <>
                    <ListItemButton
                      className="btn-sidebare"
                      onClick={handleClick8}
                    >
                      <ListItemIcon>
                        <SyncAltIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="التحويلات"
                      />
                      {open8 ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse
                      in={open8}
                      timeout="auto"
                      className="collapse-sidebar"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          component={Link}
                          to="/transcation-from"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="استعراض التحويلات  "
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </>
                ) : (
                  <></>
                
              )}

              {staff_type !== "Admin" ? (
                <></>
              ) : (
                <ListItemButton
                  component={Link}
                  to="/accounts"
                  className="btn-sidebare"
                >
                  <ListItemIcon>
                    <PointOfSaleIcon />
                  </ListItemIcon>

                  <ListItemText className="title-sidebar" primary="كشف حساب" />
                </ListItemButton>
              )}

              {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
              <>
                {staff_type == "Admin" &&
                mobile_number_login == "0950555563" ? (
                  <>
                    <ListItemButton
                      className="btn-sidebare"
                      onClick={handleClick12}
                    >
                      <ListItemIcon>
                        <AnimationIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="دفتر الحسابات والأرباح"
                      />
                      {open12 ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse
                      in={open12}
                      timeout="auto"
                      className="collapse-sidebar"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          component={Link}
                          to="ledger"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="دفتر الحسابات"
                          />
                        </ListItemButton>
                        <ListItemButton
                          component={Link}
                          to="calculate_profit"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="الارباح"
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </>
                ) : staff_type == "Admin" &&
                mobile_number_login != "0950555563" ? (
                  <></>
                ):
                  staff_type !== "Admin" ?
                  (
                    <>
                    <ListItemButton
                      className="btn-sidebare"
                      onClick={handleClick12}
                    >
                      <ListItemIcon>
                        <AnimationIcon />
                      </ListItemIcon>
                      <ListItemText
                        className="title-sidebar"
                        primary="دفتر الحسابات والأرباح"
                      />
                      {open12 ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse
                      in={open12}
                      timeout="auto"
                      className="collapse-sidebar"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        <ListItemButton
                          component={Link}
                          to="ledger"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="دفتر الحسابات"
                          />
                        </ListItemButton>
                        <ListItemButton
                          component={Link}
                          to="calculate_profit"
                          sx={{ pl: 4 }}
                        >
                          <ListItemText
                            className="title-sidebar"
                            primary="الارباح"
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </>
                  )
                :(<></>)}
              </>
              {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
              {staff_type !== "Admin" ? (
                <></>
              ) : (
                <>
                  <ListItemButton
                    className="btn-sidebare"
                    onClick={handleClick3}
                  >
                    <ListItemIcon>
                      {/* <img
                        src="../../../6.svg"
                        alt="NotificationManagement"
                      ></img> */}
                      <NotificationsActiveIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="إدارة الأشعارات"
                    />
                    {open3 ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse
                    in={open3}
                    timeout="auto"
                    className="collapse-sidebar"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/add-Notifcation"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="إرسال إشعار"
                        />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/notifcation"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="تقارير الإشعارات"
                        />
                      </ListItemButton>
                    </List>
                  </Collapse>
                  <ListItemButton
                    component={Link}
                    to="servicecenter"
                    className="btn-sidebare"
                  >
                    <ListItemIcon>
                      <SupportAgentIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="إدارة مراكز الخدمات"
                    />
                  </ListItemButton>
                  <ListItemButton
                    className="btn-sidebare"
                    onClick={handleClick4}
                  >
                    <ListItemIcon>
                      <HelpOutlineIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="إدارة صفحة المساعدة"
                    />
                    {open4 ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse
                    in={open4}
                    timeout="auto"
                    className="collapse-sidebar"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/contact"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="تعديل روابط الدعم الفني "
                        />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/help"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary=" طلبات المساعدة"
                        />
                      </ListItemButton>
                    </List>
                  </Collapse>
                  {staff_type == "Admin" &&
                  mobile_number_login == "0950555563" ? (
                    <>
                      <ListItemButton
                        className="btn-sidebare"
                        onClick={handleClick14}
                      >
                        <ListItemIcon>
                          <EngineeringIcon />
                        </ListItemIcon>
                        <ListItemText
                          className="title-sidebar"
                          primary="صيانة الموقع"
                        />
                        {open14 ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse
                        in={open14}
                        timeout="auto"
                        className="collapse-sidebar"
                        unmountOnExit
                      >
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <MaterialUISwitch
                                checked={isToggled === 1}
                                onChange={handleToggle}
                                sx={{ m: 1 }}
                              />
                            }
                            label={
                              isToggled === 1
                                ? "في حالة صيانة"
                                : "ليس في حالة صيانة"
                            }
                          />
                        </FormGroup>
                        {/* <button onClick={toggle}>
                      {isToggled ? 'Turn Off' : 'Turn On'}
                    </button> */}
                        {/* <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/contact"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary="تعديل روابط الدعم الفني "
                        />
                      </ListItemButton>
                      <ListItemButton
                        component={Link}
                        to="/help"
                        sx={{ pl: 4 }}
                      >
                        <ListItemText
                          className="title-sidebar"
                          primary=" طلبات المساعدة"
                        />
                      </ListItemButton>
                    </List> */}
                      </Collapse>
                    </>
                  ) : (
                    <></>
                  )}

                  <ListItemButton className="btn-sidebare">
                    <ListItemIcon>
                      <PhoneIphoneIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="ميزات التطبيق"
                    />
                  </ListItemButton>

                  <ListItemButton
                    component={Link}
                    to="privacy-policy"
                    className="btn-sidebare"
                  >
                    <ListItemIcon>
                      <SecurityIcon />
                    </ListItemIcon>
                    <ListItemText
                      className="title-sidebar"
                      primary="سياسة الخصوصية"
                    />
                  </ListItemButton>
                </>
              )}
            </List>
          </Menu>
        </ProSidebar>
      </Box>
    );
  }
};

export default Sidebar;
